import Box from "@mui/material/Box";
import {Fab} from "@mui/material";
import LoopIcon from '@mui/icons-material/Loop';
import {useTheme} from "../../../contexts/theme";

interface StyledFloatingActionButtonProps {
    text: string;
    onClick?: () => void;

}

export default function StyledFloatingActionButton({text, onClick}: StyledFloatingActionButtonProps) {


    const theme = useTheme();

    return (
        <Box sx={{ '& > :not(style)': { m: 1 } }}>
            <Fab
                onClick={onClick}
                variant="extended"
                sx={{
                    color: theme.palette.black,
                    backgroundColor: theme.palette.orange,
                    position: "fixed",
                    bottom: 100,   // distanza dal fondo
                    right: 10,    // distanza dal lato destro
                    zIndex: 1000, // sopra gli altri elementi
                }}
            >
                <LoopIcon sx={{ mr: 1 }} />
                {text}
            </Fab>
        </Box>

    )
}